export default __webpack_public_path__ + "static/media/avatar4.5a7ffc11.png";